const BlogContainer = ({ children }: React.PropsWithChildren<any>) => (
  <section className="mx-auto px-4 pb-28 sm:px-6 md:px-8 xl:px-12 lg:max-w-5xl">
    {children}
  </section>
)

export default BlogContainer
